import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faPlay as fasPlay } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import bankmonitorBiztonsagImage from "@img/calculator/embed/loan_insurance/BM_biztonsag_logo.png";
import bankmonitorImage from "@img/logos/bankmonitor-white.svg";
import { Button, FormCheckList } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface StepFields {
	fears: ("afraidOfLosingJob" | "afraidOfDecliningHealth" | "afraidOfUnexpectedDeath")[];
}

interface Props extends AbstractStepProps {
	variant?: string;
}

export class Step1 extends AbstractStep<StepFields, Props> {
	protected initValues(): StepFields {
		return {
			fears: [],
		};
	}

	protected renderContent(): ReactNode {
		return (
			<>
				{this.renderHeader()}
				<Card.Body className="px-4">
					<div className="py-3">
						<FormCheckList
							label="Mitől tartasz, mi befolyásolhatja a hiteled fizetését?"
							name="fears"
							options={[
								{
									label: "Elvesztem a munkámat",
									value: "afraidOfLosingJob",
								},
								{
									label: "Megromlik az egészségem",
									value: "afraidOfDecliningHealth",
								},
								{
									label: "Váratlan haláleset",
									value: "afraidOfUnexpectedDeath",
								},
							]}
							required
						/>
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasPlay} />} className="text-uppercase">
						Kalkuláció indítása
					</Button>
				</Card.Footer>
			</>
		);
	}

	private renderHeader(): ReactNode {
		const { variant } = this.props;

		if (variant === "NN") {
			return (
				<Card.Header className="text-center text-white border-top-primary py-3">
					<img className="my-1" src={bankmonitorBiztonsagImage} width="197" alt="Bankmonitor" />
				</Card.Header>
			);
		}

		return (
			<Card.Header className="bg-secondary-gradient text-center text-white">
				<img className="my-1" src={bankmonitorImage} width="160" height="25" alt="Bankmonitor" />
				<hr />
				<div className="display-5 mt-2 mb-1 text-uppercase font-weight-bold">Csoportos</div>
				<div className="text-nowrap text-uppercase font-weight-black display-4 mb-2">Személybiztosítás</div>
				<div>Töltsd ki az űrlapot, és tudd meg hogyan tudod fizetni a hiteledet baj esetén is!</div>
				<hr />
			</Card.Header>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
